import { getMiraPlusAppUrl, getTinyWinsMainAppUrl, isMiraPlusHost } from './miraplusAppUrl';
import { buildParentReferralUrl } from './parentInviteOrigin';

/** Origin for org-staff invite links (therapist, org admin) on the current product surface. */
export function getOrgInviteOrigin(): string {
  if (typeof window !== 'undefined') {
    return window.location.origin.replace(/\/+$/, '');
  }
  return isMiraPlusHost() ? getMiraPlusAppUrl() : getTinyWinsMainAppUrl();
}

export function buildOrgReferralUrl(token: string, inviteOrigin?: string): string {
  const origin = (inviteOrigin || getOrgInviteOrigin()).replace(/\/+$/, '');
  return `${origin}/org-referral?token=${encodeURIComponent(token)}`;
}

export function buildOrgAdminInviteUrl(token: string, inviteOrigin?: string): string {
  const origin = (inviteOrigin || getOrgInviteOrigin()).replace(/\/+$/, '');
  return `${origin}/org-admin?token=${encodeURIComponent(token)}`;
}

export function buildInviteLandingUrl(
  role: string,
  token: string,
  inviteOrigin?: string,
): string {
  switch (role.toUpperCase()) {
    case 'PARENT':
      // Prefer inviteOrigin from UserInvitation (e.g. localhost while testing) so the
      // token resolves against the same AppSync that created the invite.
      return buildParentReferralUrl(token, undefined, inviteOrigin);
    case 'CLINICIAN':
    case 'THERAPIST':
    case 'CAREGIVER':
    case 'INTERNS':
      return buildOrgReferralUrl(token, inviteOrigin);
    case 'ORG_ADMIN':
      return buildOrgAdminInviteUrl(token, inviteOrigin);
    default:
      return `${(inviteOrigin || getOrgInviteOrigin()).replace(/\/+$/, '')}/register?token=${encodeURIComponent(token)}`;
  }
}
